import { render, staticRenderFns } from "./Overworld.vue?vue&type=template&id=6edfc107&"
import script from "./Overworld.vue?vue&type=script&lang=js&"
export * from "./Overworld.vue?vue&type=script&lang=js&"
import style0 from "./Overworld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports